import { render } from "./MMAddNews.vue?vue&type=template&id=6d30ef54"
import script from "./MMAddNews.vue?vue&type=script&lang=js"
export * from "./MMAddNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__